export default "{\n    \"impersonateOwner\": \"Hacerse pasar por el propietario\"\n}\n"